import { render, staticRenderFns } from "./Tooth.vue?vue&type=template&id=09bc5cd1&"
import script from "./Tooth.vue?vue&type=script&lang=js&"
export * from "./Tooth.vue?vue&type=script&lang=js&"
import style0 from "./Tooth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports